<template>
  <li
    class="dropdown-option"
    :data-id="id"
    :data-depth="depth"
    :class="{
      selected: selected,
      disabled: isValid === false,
      focus: focus,
      hasChildren: children && children.length,
    }"
    @click="onClick"
    @mouseenter="focus = true"
    @mouseleave="focus = false"
  >
    <div>{{ labels[lng] || 'label' }}</div>
    <ul v-if="children && children.length">
      <node
        v-for="(child, i) in children"
        :key="i"
        v-bind="child"
        :depth="depth + 1"
        :selection="selection"
        :disabled="disabled"
        @select="broadcast('select', $event)"
        @focus="broadcast('focus', $event)"
      />
    </ul>
  </li>
</template>

<script>
export default {
  name: 'Node',
  props: ['depth', 'id', 'labels', 'children', 'isValid', 'selection', 'disabled'],
  data() {
    return {
      focus: false,
      quite: false,
    }
  },
  computed: {
    selected() {
      return this.selection.includes(this.id)
    },
  },
  watch: {
    focus(to) {
      if (this.quite) this.quite = false
      else this.$emit('focus', to)
    },
  },
  methods: {
    onClick(event) {
      event.preventDefault()
      event.stopPropagation()
      event.stopImmediatePropagation()
      if (this.disabled || this.isValid === false) return
      this.$emit('select', this.id)
    },
    broadcast(event, payload) {
      if (event === 'focus') {
        this.quite = true
        this.focus = !payload
      } else {
        this.$emit(event, payload)
      }
    },
  },
}
</script>

<style lang="stylus">
.dropdown-option
  display: block
  color: $black

  &:not([data-depth="0"])
    padding-left: vw(15px)

    .mobile &
      padding-left: vw(7.5px)

    ul
    > div
      border-left: 1px solid $alto

  > div
    position: relative
    cursor: pointer
    white-space: break-spaces
    padding: vw(10px) vw(40px) vw(10px) vw(20px)

    .mobile &
      padding: vw(7px) vw(20px) vw(5px) vw(10px)

      +m-breakpoint(landscape)
        padding: 0 vw(20px) 0 vw(10px)

  &.selected > div
    border-color: $havelock-blue
    background-color: $havelock-blue
    color: #fff

  &.disabled
    color: #bbb

    > div
      cursor: default

  &.focus:not(.selected):not(.disabled) > div
    background-color: rgba($havelock-blue, .1)
    color: $blue-2

  &.hasChildren
    ul
      padding-left: 0.5em

    > div
      font-weight: bold
</style>
